import { slices } from "@/constants/sliceNames";
import { createSlice } from "@reduxjs/toolkit";

import {
  requestRecurrentBatchPredictionsStatus,
  requestDeleteRecurrentBatchPredictionStatus,
  requestCreateRecurrentBatchPredictionStatus,
  requestUpdateRecurrentBatchPredictionStateStatus,
  requestUpdateRecurrentBatchPredictionStatus,
} from "../effects/recurrentBatch-effects";

const initialState = {
  recurrentPredictionsList: [],

  /**@type {boolean} */
  loading: false,

  item: null,

  /**@type {number} */
  recordsCount: 0,

  /**@type {number} */
  currentPage: 1,
};

const recurrentBatchSlice = createSlice({
  name: slices.recurrentBatch,
  initialState,
  extraReducers: {
    ...requestRecurrentBatchPredictionsStatus,
    ...requestDeleteRecurrentBatchPredictionStatus,
    ...requestCreateRecurrentBatchPredictionStatus,
    ...requestUpdateRecurrentBatchPredictionStateStatus,
    ...requestUpdateRecurrentBatchPredictionStatus,
  },
});

const { actions, reducer } = recurrentBatchSlice;

export { actions };

export default reducer;
